// @ts-strict-ignore
import {Component, Input, OnInit} from "@angular/core";

@Component({
	selector: "sim-labeled-info",
	templateUrl: "./labeled-info.component.html",
	styleUrls: ["./labeled-info.component.scss"],
	standalone: false,
})
export class LabeledInfoComponent implements OnInit {
	@Input() label: string;
	@Input() info: string;

	constructor() {}

	ngOnInit(): void {}
}
